/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentLanguageMap } from './DocumentLanguageMap';
import {
    DocumentLanguageMapFromJSON,
    DocumentLanguageMapFromJSONTyped,
    DocumentLanguageMapToJSON,
    DocumentLanguageMapToJSONTyped,
} from './DocumentLanguageMap';

/**
 * 
 * @export
 * @interface DistributeDocumentsRequestBulk
 */
export interface DistributeDocumentsRequestBulk {
    /**
     * 
     * @type {Array<DocumentLanguageMap>}
     * @memberof DistributeDocumentsRequestBulk
     */
    documents?: Array<DocumentLanguageMap>;
}

/**
 * Check if a given object implements the DistributeDocumentsRequestBulk interface.
 */
export function instanceOfDistributeDocumentsRequestBulk(value: object): value is DistributeDocumentsRequestBulk {
    return true;
}

export function DistributeDocumentsRequestBulkFromJSON(json: any): DistributeDocumentsRequestBulk {
    return DistributeDocumentsRequestBulkFromJSONTyped(json, false);
}

export function DistributeDocumentsRequestBulkFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeDocumentsRequestBulk {
    if (json == null) {
        return json;
    }
    return {
        
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(DocumentLanguageMapFromJSON)),
    };
}

export function DistributeDocumentsRequestBulkToJSON(json: any): DistributeDocumentsRequestBulk {
    return DistributeDocumentsRequestBulkToJSONTyped(json, false);
}

export function DistributeDocumentsRequestBulkToJSONTyped(value?: DistributeDocumentsRequestBulk | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(DocumentLanguageMapToJSON)),
    };
}

